module.exports = __webpack_public_path__ + "img/boba-tea.384ecdf1.jpg";